import {
  registerPageTab,
  addNavMenuItem,
  registerBulkAction,
  PageLocationId,
} from "@bb-vendure/admin-ui/core";
import { QAPageComponent } from "./components/QA-Page/qa.component";
import { bulkRemoveQuestions } from "./components/QA-Page/helpers/bulkAction";
import { QAOrderTableComponent } from "./components/qa-order-table/qa-order-table.component";
import { QACustomerTableComponent } from "./components/qa-customer-table/qa-customer-table.component";

export default [
  registerBulkAction(bulkRemoveQuestions),
  addNavMenuItem(
    {
      id: "qa-management",
      label: "qa.management",
      routerLink: ["/extensions/qa"],
      icon: "unknown-status",
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadQuestionPost");
      },
    },
    "sales"
  ),

  // addNavMenuItem(
  //   {
  //     id: "qa-order-management",
  //     label: "Q&A Order Management",
  //     routerLink: ["/extensions/qa-order"],
  //     icon: "unknown-status",
  //     requiresPermission: (userPermissions) => {
  //       return userPermissions.includes("ReadQuestionPost");
  //     },
  //   },
  //   "sales"
  // ),

  registerPageTab({
    location: "qa-list" as PageLocationId,
    tab: "qa.product-management",
    route: "/extensions/qa",
    //tabIcon: "star",
    component: QAPageComponent,
  }),

  registerPageTab({
    location: "qa-list" as PageLocationId,
    tab: "qa.order-management",
    route: "/extensions/qa/order",
    //tabIcon: "star",
    component: QAOrderTableComponent,
  }),

  registerPageTab({
    location: "qa-list" as PageLocationId,
    tab: "qa.customer-management",
    route: "/extensions/qa/customer",
    //tabIcon: "star",
    component: QACustomerTableComponent,
  }),
];
